import { ArrowUp, Phone, Mail, MapPin } from "lucide-react";
import { PHONE_DISPLAY, EMAIL, ADDRESS } from "@/data";
import Socials from "@/components/Socials";

export default function Footer() {
  const toTop = (e) => {
    e.preventDefault();
    if (window.__lenis) window.__lenis.scrollTo(0);
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer data-testid="footer" className="relative border-t border-gold/15 bg-obsidian overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-10">
        <div className="flex flex-col lg:flex-row justify-between gap-12">
          <div className="max-w-md">
            <img src="/assets/logo-full.png" alt="Auto City Lubricants" className="h-24 w-auto object-contain bg-white rounded-xl px-4 py-3" data-testid="footer-logo" />
            <p className="mt-6 text-sm text-zinc-400 leading-relaxed">
              Auto City Lubricants (PTY) Ltd — a registered ® LOBP (Lubricant Oil Blending Plant).
              Supplier of industrial, automotive, mining and agricultural lubricants. Quality
              products. Reliable service. Always.
            </p>
          </div>
          <div className="flex flex-col gap-4 text-sm">
            <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-gold mb-1">Reach Us</p>
            <a data-testid="footer-phone" href={`tel:${PHONE_DISPLAY.replace(/\s/g, "")}`} className="flex items-center gap-3 text-zinc-300 hover:text-gold transition-colors duration-300">
              <Phone size={15} className="text-gold" /> {PHONE_DISPLAY}
            </a>
            <a data-testid="footer-email" href={`mailto:${EMAIL}`} className="flex items-center gap-3 text-zinc-300 hover:text-gold transition-colors duration-300">
              <Mail size={15} className="text-gold" /> {EMAIL}
            </a>
            <p data-testid="footer-address" className="flex items-start gap-3 text-zinc-300">
              <MapPin size={15} className="text-gold mt-0.5 shrink-0" /> {ADDRESS}
            </p>
            <Socials className="mt-2" />
          </div>
          <div className="flex lg:justify-end items-start">
            <a
              data-testid="footer-back-to-top"
              href="#top"
              onClick={toTop}
              className="inline-flex items-center gap-2 border border-gold/40 text-gold text-xs font-bold uppercase tracking-widest px-6 py-3.5 rounded-full hover:bg-gold hover:text-obsidian transition-all duration-300"
            >
              <ArrowUp size={15} /> Back to Top
            </a>
          </div>
        </div>

        <p
          data-testid="footer-giant-text"
          className="mt-20 font-heading font-black uppercase text-center leading-none tracking-tight text-outline-gold select-none text-[13.5vw] lg:text-[10rem]"
        >
          AUTO CITY
        </p>

        <div className="mt-10 pt-8 border-t border-gold/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-500">© 2026 Auto City Lubricants (PTY) Ltd. All rights reserved.</p>
          <p className="text-xs uppercase tracking-widest text-gold/70">
            Quality Lubricants. A Stronger Tomorrow.
          </p>
        </div>
      </div>
    </footer>
  );
}
